import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Products = Loader(lazy(() => import("src/content/products")));

const productRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Ürünler </title>
        </Helmet>
        <Products />
      </>
    ),
  },
];

export default productRoutes;
